import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import FloatingContactButtons from './components/chat/FloatingContactButtons.vue' // 悬浮按钮

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.component('FloatingContactButtons', FloatingContactButtons)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 